export const paymentsReportsData = {
  transactionsCount: 2471,
  transactionsTotal: -142359.07,
  refundsCount: 34,
  refundsTotal: 435.91,
  pendingChargebacksCount: 62,
  pendingChargebacksTotal: -674.23,
  completedChargebacksCount: 0,
  completedChargebacksTotal: 0,
  feesTotal: 5293.29,
  resultingTotal: 135955.64,
  payoutsCount: 4,
  payoutsTotal: 115432.23,
  lastDepositDate: '2022-31-10',
  cardSummary: {
    count: 2471,
    amountTotal: 120545.52,
    refundTotal: 435.91,
    resultingTotal: 142359.07,
    summary: {
      AMEX: {
        count: 345,
        amountTotal: 17787.24,
        refundTotal: 0.0,
        resultingTotal: -20483.32,
      },
      DISCOVER: {
        count: 0,
        amountTotal: 3793.93,
        refundTotal: 0.0,
        resultingTotal: 4592.33,
      },
      MASTERCARD: {
        count: 444,
        amountTotal: 20199.1,
        refundTotal: 0.0,
        resultingTotal: 25392.32,
      },
      VISA: {
        count: 1608,
        amountTotal: 78765.25,
        refundTotal: 0.0,
        resultingTotal: 92843.39,
      },
    },
  },
};

export const paymentsReportsDataWithoutCardSummary = {
  transactionsCount: 2471,
  transactionsTotal: -142359.07,
  refundsCount: 34,
  refundsTotal: 435.91,
  pendingChargebacksCount: 62,
  pendingChargebacksTotal: -674.23,
  completedChargebacksCount: 0,
  completedChargebacksTotal: 0,
  feesTotal: 5293.29,
  resultingTotal: 135955.64,
  payoutsCount: 4,
  payoutsTotal: 115432.23,
  lastDepositDate: '2022-31-10',
};
